module.exports = __webpack_public_path__ + "static/media/orange.7c91d5a6.png";